import BaseErrorPage from '../../../Components/BaseErrorPage'
import Link from '@mui/material/Link'

const StandardErrorPage = (): JSX.Element => (
  <BaseErrorPage>
    Unfortunately what you are looking for may no longer be available.
    <br />
    If you have questions or feedback, please get in touch:{' '}
    <Link variant='anchor' href='mailto:support@headbox.com'>
      support@headbox.com
    </Link>
  </BaseErrorPage>
)

export default StandardErrorPage
